import React from "react";
import * as PropTypes from "prop-types";
import { isIE } from "../../utilities";
import ComponentWithFallback from "./ComponentWithFallback";

const ComponentWithIeFallback = props => (
  <ComponentWithFallback
    useFallbackComponent={isIE()}
    fallbackComponent={props.fallbackComponent}
  >
    {props.children}
  </ComponentWithFallback>
);

ComponentWithIeFallback.propTypes = {
  children: PropTypes.element.isRequired,
  fallbackComponent: PropTypes.element
};

export default ComponentWithIeFallback;
